import { Pipe, PipeTransform } from '@angular/core';
import { PlaylistDTO } from '../models/view-models/playlist-models/playlist-dto.model';

@Pipe({
  name: 'playlistLocationFilter'
})
export class PlaylistLocationFilter implements PipeTransform {
  transform(items: PlaylistDTO[], isGeneric = false) {
    if (items && items.length) {
      if (!isGeneric) {
        return items.filter((x) => x.MachinePhysicalAddress);
      }
      return items.filter((x) => !x.MachinePhysicalAddress);
    }
  }
}
